import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import ComponentEventBus, { IComponentWrapper, Events } from 'Events/ComponentWrapperEventBus';




@Component({
})
export default class ComponentWrapperComponent extends Vue {
    
    public customComponents = new Map<string, any>(); 
    public count: number = 0;
    
    created() {
        ComponentEventBus.$on(Events.ADD, (payload: IComponentWrapper) => {
            this.customComponents.set(payload.type, {
                type: payload.type,
                id: this.count++
            });

            // this.$forceUpdate();
        });
        
        
        ComponentEventBus.$on(Events.REMOVE, (payload : IComponentWrapper) => {
            
            this.customComponents.delete(payload.type);
            this.count--;
            // // destroy the vue listeners, etc
            // payload.instance.$destroy();
            
            // // remove the element from the DOM
            // payload.instance.$el.parentNode.removeChild(payload.instance.$el);
            
            // console.log('remove me pleasee...')
        });
        

       
        
    }

    get listOfComponents(): Array<string>{
        this.count; //hack to force update!!
        return Array.from(this.customComponents.keys());
    }

}

Vue.component('component-wrapper', ComponentWrapperComponent);